import ApexCharts from 'apexcharts';
  const generateChartImage = async (id,charttype,remarkValue) => {
    const chartInstance = ApexCharts.getChartByID(id);
    if (chartInstance) {
      try {
        const { imgURI } = await chartInstance.dataURI();        
        const chartData = JSON.parse(localStorage.getItem("chartImageData")) || [];
        if (charttype === 'maturity_benchmark_line') {
          const updatedChartData = chartData.map((item) => {
            if (item.id === charttype) {
              // Check if the subimage with the same id already exists
              const existingSubImageIndex = item.subimage.findIndex(
                (sub) => sub.id === id // Use the unique identifier of the subimage
              );
        
              let updatedSubimages;
              if (existingSubImageIndex !== -1) {
                // Update the existing subimage
                updatedSubimages = item.subimage.map((sub, index) =>
                  index === existingSubImageIndex ? { ...sub, id, image: imgURI } : sub
                );
              } else {
                // Add the new subimage if it doesn't already exist
                updatedSubimages = [...item.subimage, { id, image: imgURI }];
              }
        
              return { ...item, subimage: updatedSubimages, remark: remarkValue};
            }
            return item;
          });
        
          localStorage.setItem("chartImageData", JSON.stringify(updatedChartData));
        }else if (charttype === 'maturity_line') {
          const updatedChartData = chartData.map((item) => {
            if (item.id === charttype) {
              // Check if the subimage with the same id already exists
              const existingSubImageIndex = item.subimage.findIndex(
                (sub) => sub.id === id // Use the unique identifier of the subimage
              );
        
              let updatedSubimages;
              if (existingSubImageIndex !== -1) {
                // Update the existing subimage
                updatedSubimages = item.subimage.map((sub, index) =>
                  index === existingSubImageIndex ? { ...sub, id, image: imgURI } : sub
                );
              } else {
                // Add the new subimage if it doesn't already exist
                updatedSubimages = [...item.subimage, { id, image: imgURI }];
              }
        
              return { ...item, subimage: updatedSubimages, remark: remarkValue};
            }
            return item;
          });
        
          localStorage.setItem("chartImageData", JSON.stringify(updatedChartData));
        }else if (charttype === 'customer_dimension_current') {
          const updatedChartData = chartData.map((item) => {
            if (item.id === charttype) {
              // Check if the subimage with the same id already exists
              const existingSubImageIndex = item.subimage.findIndex(
                (sub) => sub.id === id // Use the unique identifier of the subimage
              );
        
              let updatedSubimages;
              if (existingSubImageIndex !== -1) {
                // Update the existing subimage
                updatedSubimages = item.subimage.map((sub, index) =>
                  index === existingSubImageIndex ? { ...sub, id, image: imgURI } : sub
                );
              } else {
                // Add the new subimage if it doesn't already exist
                updatedSubimages = [...item.subimage, { id, image: imgURI }];
              }
        
              return { ...item, subimage: updatedSubimages, remark: remarkValue};
            }
            return item;
          });
        
          localStorage.setItem("chartImageData", JSON.stringify(updatedChartData));
        }else if (charttype === 'customer_dimension_future') {
          const updatedChartData = chartData.map((item) => {
            if (item.id === charttype) {
              // Check if the subimage with the same id already exists
              const existingSubImageIndex = item.subimage.findIndex(
                (sub) => sub.id === id // Use the unique identifier of the subimage
              );
        
              let updatedSubimages;
              if (existingSubImageIndex !== -1) {
                // Update the existing subimage
                updatedSubimages = item.subimage.map((sub, index) =>
                  index === existingSubImageIndex ? { ...sub, id, image: imgURI } : sub
                );
              } else {
                // Add the new subimage if it doesn't already exist
                updatedSubimages = [...item.subimage, { id, image: imgURI }];
              }
        
              return { ...item, subimage: updatedSubimages, remark: remarkValue}; 
            }
            return item;
          });
        
          localStorage.setItem("chartImageData", JSON.stringify(updatedChartData));
        } else {
          const updatedChartData = chartData.map((item) =>
            item.id === charttype ? { ...item, remark:remarkValue, image: imgURI } : item
          );
          localStorage.setItem("chartImageData", JSON.stringify(updatedChartData));
        }
        
       
       
       } catch (error) {
        console.error("Error generating chart image:", error);
      }
    } else {
      console.error("Chart instance not found.");
    }
  };

  export default generateChartImage;